import SvgIcon from '@mui/material/SvgIcon';

export default function ArrowOutwardIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M18.7071 7C18.7071 6.44772 18.2594 6 17.7071 6H8.70711C8.15483 6 7.70711 6.44772 7.70711 7C7.70711 7.55228 8.15483 8 8.70711 8H16.7071V16C16.7071 16.5523 17.1548 17 17.7071 17C18.2594 17 18.7071 16.5523 18.7071 16V7ZM7.41422 18.7071L18.4142 7.70711L17 6.29289L6 17.2929L7.41422 18.7071Z" />
    </SvgIcon>
  );
}
